export const translatableFields: Record<string, string[]> = {
  'resources:resources_resource': ['name', 'description'],
  'resources:resources_resource_type': ['name', 'description'],
}

export default translatableFields
